exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports
exports.locals = {
	"breakpoint_xs": "0",
	"breakpoint_sm": "520px",
	"breakpoint_md": "720px",
	"breakpoint_lg": "992px",
	"breakpoint_xl": "1200px"
};